import React, { useState } from 'react';
import TenderDetail from './TenderDetail';
import { Tender } from '../types';

interface TenderDetailNavigatorProps {
  tenders: Tender[];
  initialIndex?: number;
  onClose: () => void;
  onCreateApplication: (tender: Tender) => void;
}

const TenderDetailNavigator: React.FC<TenderDetailNavigatorProps> = ({ tenders, initialIndex = 0, onClose, onCreateApplication }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const handleNavigate = (direction: 'prev' | 'next') => {
    setCurrentIndex((prev) => {
      if (direction === 'prev') return Math.max(0, prev - 1);
      if (direction === 'next') return Math.min(tenders.length - 1, prev + 1);
      return prev;
    });
  };

  if (tenders.length === 0) return <div>No hay licitaciones para mostrar.</div>;

  return (
    <TenderDetail
      tender={tenders[currentIndex]}
      onClose={onClose}
      onNavigate={handleNavigate}
      showPrev={currentIndex > 0}
      showNext={currentIndex < tenders.length - 1}
      onCreateApplication={onCreateApplication}
    />
  );
};

export default TenderDetailNavigator; 